import { updateState } from '@angular-architects/ngrx-toolkit';
import {
    signalStore,
    withComputed,
    withMethods,
    withState,
} from '@ngrx/signals';
import { environment } from '@dxp/core/environment';
import type { IDirectoryListing } from '@dxp/core/models';

interface IContactStore {
    directoryScreen: string;
    activeTab: string;
    selectedContact: IDirectoryListing | null;
}

const initialState: IContactStore = {
    directoryScreen: '',
    activeTab: '',
    selectedContact: null,
};

export const ContactStore = signalStore(
    { providedIn: 'root' },
    environment.storeWithDevTools('ContactStore'),

    withState(initialState),
    withComputed(store => ({
        currentTab: () => store.activeTab(),
        currentSelectedContact: () => store.selectedContact(),
        currentSelectedContactId: () => `${store.selectedContact()?.id ?? ''}`,
        currentSelectedContactDetail: () => {
            const selectedContact = store.selectedContact() as any;
            return {
                id: +`${store.selectedContact()?.id ?? ''}`,
                fullName: `${store.selectedContact()?.name ?? ''}`,
                emailAddress: `${store.selectedContact()?.email ?? ''}`,
                phoneNumber: `${store.selectedContact()?.phoneNumber ?? ''}`,
                directory:
                    selectedContact?.directory?.id ?? selectedContact.directory,
                customFields: [],
            };
        },
        contactSelectionEmpty: () => store.selectedContact() === null,
    })),
    withMethods(store => ({
        updateDirectoryScreen(screen: string) {
            updateState(store, 'UPDATE_DIRECTORY_SCREEN', {
                directoryScreen: screen,
            });
        },
        /**
         * @todo When all contact directories are added - Type the tabname
         *
         * @param tabName
         */
        updateActiveTab(tabName: string) {
            updateState(store, 'UPDATE_CONTACTS_ACTIVE_TAB', {
                activeTab: tabName,
            });
        },
        updateSelectedContact(contact: IDirectoryListing | null) {
            updateState(store, 'UPDATE_CONTACTS_SELECTED_CONTACT', {
                selectedContact: contact,
            });
        },
        clearSelectedContact() {
            updateState(store, 'UPDATE_CONTACTS_SELECTED_CONTACT', {
                selectedContact: null,
            });
        },
    })),
);
